import React, { useContext, useState } from "react";
import { Box, Paper, Snackbar } from "@mui/material";
import { TableContainer } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { del, post } from "../../../Services/tokenConfig";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { IEfetivoPecuarioGH1, INecessidadesDia, INecessidadesTotais } from "../../../Interfaces/eficiencia_alimentar/planoAlimentar_GrupoHomo";
import { StyledTableCell, StyledTableHead, StyledTableHeadLeft } from "../../../Styles/tabelCellStyled/customTableCell";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { func_print } from "../../../Func_genericas/func_print";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { Alert } from "../../../Components/Alert/Alert";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { format_strings_to_numbers, somaCampoAnimais, somaCampoCN } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";

interface IPecuarioProps {
  tabela: IEfetivoPecuarioGH1 | undefined;
  setTabela: React.Dispatch<React.SetStateAction<IEfetivoPecuarioGH1 | undefined>>;
  set_necessidades_dia: React.Dispatch<React.SetStateAction<INecessidadesDia | undefined>>;
  set_necessidades_total: React.Dispatch<React.SetStateAction<INecessidadesTotais | undefined>>;
  especie_ou_lote_homegenio_selecionada: IGrupos_Homo_Eficiencia_Alimentar | undefined;
}

export const EfetivoPecuarioEFGH1: React.FC<IPecuarioProps> = ({
  tabela,
  setTabela,
  especie_ou_lote_homegenio_selecionada,
  set_necessidades_dia,
  set_necessidades_total
}) => {
  const auth = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const [obj_tabela_editar, set_obj_tabela_editar] = useState<IEfetivoPecuarioGH1>();
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const [create, setCreate] = useState(false);
  const [editRow, setEditRow] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null | undefined>(null);
  const [openDelete, setOpenDelete] = React.useState(false);


  const [error_camp_1_animais, set_error_camp_1_animais] = useState<boolean>(false);
  const [error_camp_2_animais, set_error_camp_2_animais] = useState<boolean>(false);
  const [error_camp_3_animais, set_error_camp_3_animais] = useState<boolean>(false);
  const [error_camp_4_animais, set_error_camp_4_animais] = useState<boolean>(false);
  const [error_camp_5_animais, set_error_camp_5_animais] = useState<boolean>(false);
  const [error_camp_6_animais, set_error_camp_6_animais] = useState<boolean>(false);
  const [error_camp_7_animais, set_error_camp_7_animais] = useState<boolean>(false);
  const [error_camp_8_animais, set_error_camp_8_animais] = useState<boolean>(false);
  const [error_camp_1_dias, set_error_camp_1_dias] = useState<boolean>(false);
  const [error_camp_2_dias, set_error_camp_2_dias] = useState<boolean>(false);
  const [error_camp_3_dias, set_error_camp_3_dias] = useState<boolean>(false);
  const [error_camp_4_dias, set_error_camp_4_dias] = useState<boolean>(false);
  const [error_camp_5_dias, set_error_camp_5_dias] = useState<boolean>(false);
  const [error_camp_6_dias, set_error_camp_6_dias] = useState<boolean>(false);
  const [error_camp_7_dias, set_error_camp_7_dias] = useState<boolean>(false);
  const [error_camp_8_dias, set_error_camp_8_dias] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);


  const handleCloseDialog = () => {
    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const reset_valores_ref = () => {
    set_error_camp_1_animais(false)
    set_error_camp_2_animais(false)
    set_error_camp_3_animais(false)
    set_error_camp_4_animais(false)
    set_error_camp_5_animais(false)
    set_error_camp_6_animais(false)
    set_error_camp_7_animais(false)
    set_error_camp_8_animais(false)
    set_error_camp_1_dias(false)
    set_error_camp_2_dias(false)
    set_error_camp_3_dias(false)
    set_error_camp_4_dias(false)
    set_error_camp_5_dias(false)
    set_error_camp_6_dias(false)
    set_error_camp_7_dias(false)
    set_error_camp_8_dias(false)
  }


  const handleCancel = () => {
    setCreate(false);
    set_obj_tabela_editar(undefined);
    setEditRow(false);
    reset_valores_ref();
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    if (name === 'camp_1_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_1_animais(true)
      } else {
        set_error_camp_1_animais(false)

        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.4
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_1_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }

    } else if (name === 'camp_2_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_2_animais(true)
      } else {
        set_error_camp_2_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.4
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_2_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }

    } else if (name === 'camp_3_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_3_animais(true)
      } else {
        set_error_camp_3_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.6
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_3_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }

    } else if (name === 'camp_4_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_4_animais(true)
      } else {
        set_error_camp_4_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.6
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_4_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_5_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_5_animais(true)
      } else {
        set_error_camp_5_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.6
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_5_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_6_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_6_animais(true)
      } else {
        set_error_camp_6_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value * 0.6
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_6_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_7_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_7_animais(true)
      } else {
        set_error_camp_7_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_7_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_8_animais') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_8_animais(true)
      } else {
        set_error_camp_8_animais(false)
        let aux_value1 = format_strings_to_numbers(value)
        let aux_value = typeof (aux_value1) === 'number' ? aux_value1 : 0
        let camp_cn = aux_value
        set_obj_tabela_editar((prevManeio: any) => ({
          ...prevManeio,
          'camp_8_cn': camp_cn,
          [name]: format_strings_to_numbers(value, false),
        }));
      }
    } else if (name === 'camp_1_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_1_dias(true)
      } else {
        set_error_camp_1_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_2_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_2_dias(true)
      } else {
        set_error_camp_2_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_3_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_3_dias(true)
      } else {
        set_error_camp_3_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_4_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_4_dias(true)
      } else {
        set_error_camp_4_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_5_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_5_dias(true)
      } else {
        set_error_camp_5_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_6_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_6_dias(true)
      } else {
        set_error_camp_6_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_7_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_7_dias(true)
      } else {
        set_error_camp_7_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else if (name === 'camp_8_dias') {
      if (/[a-zA-Z]/.test(value)) {
        set_error_camp_8_dias(true)
      } else {
        set_error_camp_8_dias(false)
      }
      set_obj_tabela_editar((old: any) => ({
        ...old,
        [name]: format_strings_to_numbers(value, false),
      }));
    } else {
      set_obj_tabela_editar((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }
  };

  const handleSave = () => {
    if (editRow === true) {
      handleUpdatetabela();
    } else {
      handleSaveTabela();
    }
  }

  const handleSaveTabela = async () => {
    if (obj_tabela_editar === undefined
    ) {
      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else

      try {
        let res = await post(auth.token.cookie_token, "new_efetivo_pecuario", {
          payload: {
            id_producao: 0,

            camp_1_animais: obj_tabela_editar?.camp_1_animais === undefined || obj_tabela_editar?.camp_1_animais === null ? 0 : obj_tabela_editar?.camp_1_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_animais,
            camp_2_animais: obj_tabela_editar?.camp_2_animais === undefined || obj_tabela_editar?.camp_2_animais === null ? 0 : obj_tabela_editar?.camp_2_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_animais,
            camp_3_animais: obj_tabela_editar?.camp_3_animais === undefined || obj_tabela_editar?.camp_3_animais === null ? 0 : obj_tabela_editar?.camp_3_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_animais,
            camp_4_animais: obj_tabela_editar?.camp_4_animais === undefined || obj_tabela_editar?.camp_4_animais === null ? 0 : obj_tabela_editar?.camp_4_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_animais,
            camp_5_animais: obj_tabela_editar?.camp_5_animais === undefined || obj_tabela_editar?.camp_5_animais === null ? 0 : obj_tabela_editar?.camp_5_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_animais,
            camp_6_animais: obj_tabela_editar?.camp_6_animais === undefined || obj_tabela_editar?.camp_6_animais === null ? 0 : obj_tabela_editar?.camp_6_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_animais,
            camp_7_animais: obj_tabela_editar?.camp_7_animais === undefined || obj_tabela_editar?.camp_7_animais === null ? 0 : obj_tabela_editar?.camp_7_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_animais,
            camp_8_animais: obj_tabela_editar?.camp_8_animais === undefined || obj_tabela_editar?.camp_8_animais === null ? 0 : obj_tabela_editar?.camp_8_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_animais,
            camp_1_dias: obj_tabela_editar?.camp_1_dias === undefined || obj_tabela_editar?.camp_1_dias === null ? 0 : obj_tabela_editar?.camp_1_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_dias,
            camp_2_dias: obj_tabela_editar?.camp_2_dias === undefined || obj_tabela_editar?.camp_2_dias === null ? 0 : obj_tabela_editar?.camp_2_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_dias,
            camp_3_dias: obj_tabela_editar?.camp_3_dias === undefined || obj_tabela_editar?.camp_3_dias === null ? 0 : obj_tabela_editar?.camp_3_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_dias,
            camp_4_dias: obj_tabela_editar?.camp_4_dias === undefined || obj_tabela_editar?.camp_4_dias === null ? 0 : obj_tabela_editar?.camp_4_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_dias,
            camp_5_dias: obj_tabela_editar?.camp_5_dias === undefined || obj_tabela_editar?.camp_5_dias === null ? 0 : obj_tabela_editar?.camp_5_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_dias,
            camp_6_dias: obj_tabela_editar?.camp_6_dias === undefined || obj_tabela_editar?.camp_6_dias === null ? 0 : obj_tabela_editar?.camp_6_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_dias,
            camp_7_dias: obj_tabela_editar?.camp_7_dias === undefined || obj_tabela_editar?.camp_7_dias === null ? 0 : obj_tabela_editar?.camp_7_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_dias,
            camp_8_dias: obj_tabela_editar?.camp_8_dias === undefined || obj_tabela_editar?.camp_8_dias === null ? 0 : obj_tabela_editar?.camp_8_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_dias,
            camp_1_cn: obj_tabela_editar?.camp_1_cn === undefined || obj_tabela_editar?.camp_1_cn === null ? 0 : obj_tabela_editar?.camp_1_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_cn,
            camp_2_cn: obj_tabela_editar?.camp_2_cn === undefined || obj_tabela_editar?.camp_2_cn === null ? 0 : obj_tabela_editar?.camp_2_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_cn,
            camp_3_cn: obj_tabela_editar?.camp_3_cn === undefined || obj_tabela_editar?.camp_3_cn === null ? 0 : obj_tabela_editar?.camp_3_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_cn,
            camp_4_cn: obj_tabela_editar?.camp_4_cn === undefined || obj_tabela_editar?.camp_4_cn === null ? 0 : obj_tabela_editar?.camp_4_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_cn,
            camp_5_cn: obj_tabela_editar?.camp_5_cn === undefined || obj_tabela_editar?.camp_5_cn === null ? 0 : obj_tabela_editar?.camp_5_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_cn,
            camp_6_cn: obj_tabela_editar?.camp_6_cn === undefined || obj_tabela_editar?.camp_6_cn === null ? 0 : obj_tabela_editar?.camp_6_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_cn,
            camp_7_cn: obj_tabela_editar?.camp_7_cn === undefined || obj_tabela_editar?.camp_7_cn === null ? 0 : obj_tabela_editar?.camp_7_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_cn,
            camp_8_cn: obj_tabela_editar?.camp_8_cn === undefined || obj_tabela_editar?.camp_8_cn === null ? 0 : obj_tabela_editar?.camp_8_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_cn,
            total: somaCampoCN(obj_tabela_editar),
            id_grupo: especie_ou_lote_homegenio_selecionada?.id_grupo,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setTabela(res.data.result[2]);
          set_necessidades_total(res.data.result[0])
          set_necessidades_dia(res.data.result[1])
          set_flag_editado(false)

          set_obj_tabela_editar(undefined);
          setCreate(false);
          setEditRow(false);
          reset_valores_ref();
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveTabela", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
  }

  const handleEdit = (obj: IEfetivoPecuarioGH1 | undefined) => {
    set_obj_tabela_editar(obj);
    setEditRow(true);

  };

  const handleUpdatetabela = async () => {
    try {

      setIsLoading(true);
      let res = await post(auth.token.cookie_token, `update_efetivo_pecuario`, {
        payload: {
          id_producao: obj_tabela_editar?.id_producao,
          camp_1_animais: obj_tabela_editar?.camp_1_animais === undefined || obj_tabela_editar?.camp_1_animais === null ? 0 : obj_tabela_editar?.camp_1_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_animais,
          camp_2_animais: obj_tabela_editar?.camp_2_animais === undefined || obj_tabela_editar?.camp_2_animais === null ? 0 : obj_tabela_editar?.camp_2_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_animais,
          camp_3_animais: obj_tabela_editar?.camp_3_animais === undefined || obj_tabela_editar?.camp_3_animais === null ? 0 : obj_tabela_editar?.camp_3_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_animais,
          camp_4_animais: obj_tabela_editar?.camp_4_animais === undefined || obj_tabela_editar?.camp_4_animais === null ? 0 : obj_tabela_editar?.camp_4_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_animais,
          camp_5_animais: obj_tabela_editar?.camp_5_animais === undefined || obj_tabela_editar?.camp_5_animais === null ? 0 : obj_tabela_editar?.camp_5_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_animais,
          camp_6_animais: obj_tabela_editar?.camp_6_animais === undefined || obj_tabela_editar?.camp_6_animais === null ? 0 : obj_tabela_editar?.camp_6_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_animais,
          camp_7_animais: obj_tabela_editar?.camp_7_animais === undefined || obj_tabela_editar?.camp_7_animais === null ? 0 : obj_tabela_editar?.camp_7_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_animais,
          camp_8_animais: obj_tabela_editar?.camp_8_animais === undefined || obj_tabela_editar?.camp_8_animais === null ? 0 : obj_tabela_editar?.camp_8_animais.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_animais,
          camp_1_dias: obj_tabela_editar?.camp_1_dias === undefined || obj_tabela_editar?.camp_1_dias === null ? 0 : obj_tabela_editar?.camp_1_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_dias,
          camp_2_dias: obj_tabela_editar?.camp_2_dias === undefined || obj_tabela_editar?.camp_2_dias === null ? 0 : obj_tabela_editar?.camp_2_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_dias,
          camp_3_dias: obj_tabela_editar?.camp_3_dias === undefined || obj_tabela_editar?.camp_3_dias === null ? 0 : obj_tabela_editar?.camp_3_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_dias,
          camp_4_dias: obj_tabela_editar?.camp_4_dias === undefined || obj_tabela_editar?.camp_4_dias === null ? 0 : obj_tabela_editar?.camp_4_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_dias,
          camp_5_dias: obj_tabela_editar?.camp_5_dias === undefined || obj_tabela_editar?.camp_5_dias === null ? 0 : obj_tabela_editar?.camp_5_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_dias,
          camp_6_dias: obj_tabela_editar?.camp_6_dias === undefined || obj_tabela_editar?.camp_6_dias === null ? 0 : obj_tabela_editar?.camp_6_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_dias,
          camp_7_dias: obj_tabela_editar?.camp_7_dias === undefined || obj_tabela_editar?.camp_7_dias === null ? 0 : obj_tabela_editar?.camp_7_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_dias,
          camp_8_dias: obj_tabela_editar?.camp_8_dias === undefined || obj_tabela_editar?.camp_8_dias === null ? 0 : obj_tabela_editar?.camp_8_dias.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_dias,
          camp_1_cn: obj_tabela_editar?.camp_1_cn === undefined || obj_tabela_editar?.camp_1_cn === null ? 0 : obj_tabela_editar?.camp_1_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_1_cn,
          camp_2_cn: obj_tabela_editar?.camp_2_cn === undefined || obj_tabela_editar?.camp_2_cn === null ? 0 : obj_tabela_editar?.camp_2_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_2_cn,
          camp_3_cn: obj_tabela_editar?.camp_3_cn === undefined || obj_tabela_editar?.camp_3_cn === null ? 0 : obj_tabela_editar?.camp_3_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_3_cn,
          camp_4_cn: obj_tabela_editar?.camp_4_cn === undefined || obj_tabela_editar?.camp_4_cn === null ? 0 : obj_tabela_editar?.camp_4_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_4_cn,
          camp_5_cn: obj_tabela_editar?.camp_5_cn === undefined || obj_tabela_editar?.camp_5_cn === null ? 0 : obj_tabela_editar?.camp_5_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_5_cn,
          camp_6_cn: obj_tabela_editar?.camp_6_cn === undefined || obj_tabela_editar?.camp_6_cn === null ? 0 : obj_tabela_editar?.camp_6_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_6_cn,
          camp_7_cn: obj_tabela_editar?.camp_7_cn === undefined || obj_tabela_editar?.camp_7_cn === null ? 0 : obj_tabela_editar?.camp_7_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_7_cn,
          camp_8_cn: obj_tabela_editar?.camp_8_cn === undefined || obj_tabela_editar?.camp_8_cn === null ? 0 : obj_tabela_editar?.camp_8_cn.toString().length === 0 ? 0 : obj_tabela_editar.camp_8_cn,
          total: somaCampoCN(obj_tabela_editar),
          id_grupo: especie_ou_lote_homegenio_selecionada?.id_grupo,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        setTabela(res.data.result[2]);
        set_necessidades_total(res.data.result[0])
        set_necessidades_dia(res.data.result[1])
        set_obj_tabela_editar(undefined);
        setEditRow(false);
        set_flag_editado(false)
        reset_valores_ref();
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdatetabela", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  // DELETE
  const handleClickOpenDelete = (id: number | null | undefined) => {
    setIdToDelete(id);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      if (idToDelete !== null) {
        setIsLoading(true);

        let res = await del(auth.token.cookie_token, `/delete_efetivo_pecuario/${idToDelete}`);

        if (res.status === 200) {
          setMessage("Registo eliminado com sucesso!");
          setOpenDelete(false);
          setIdToDelete(null);

          setTabela(undefined)
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };



  return (
    <>
      {isLoading ?
        <LoadingVulpes /> :
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>

          <table style={{ width: "50%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={10}
                  sx={{
                    fontWeight: 700,
                    fontSize: 18,
                    fontFamily: "candara",
                  }}
                >
                  Plano de Alimentação - Grupo Homogéneo 1
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={3}
                  sx={{
                    fontWeight: 700,
                    fontSize: 16,
                    fontFamily: "candara",
                  }}
                >
                  1. Efetivo Pecuário
                </TableCell>
                {tabela === undefined && create === false && editRow === false ?
                  <TableCell >
                    <Box sx={{ display: "flex", justifyContent: "end" }}>
                      <BarraDeFerramentas
                        mostrarBotaoNovo
                        textoBotaoNovo="Novo Registo"
                        aoClicarNovo={() => setCreate(true)}
                      />
                    </Box>
                  </TableCell>
                  :
                  tabela !== undefined && create === false && editRow === false ?
                    <TableCell
                      colSpan={8}
                      sx={{ alignItems: "center", justifyContent: "end" }}
                    >
                      <ButtonCadernos
                        mostrarBotaoEditar
                        aoClicarEditar={() => handleEdit(tabela)}
                        mostrarBotaoApagar
                        aoClicarApagar={() => handleClickOpenDelete(tabela?.id_producao)}
                      />
                    </TableCell>
                    :
                    <TableCell>
                      <Box sx={{ display: "flex", justifyContent: "end" }}>
                        <ButtonCadernos
                          mostrarBotaoCancelar
                          aoClicarCancelar={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                            } else {
                              handleCancel()
                            }
                          }}
                          mostrarBotaoGravar
                          aoClicarGravar={() => handleSave()}
                        />
                      </Box>
                    </TableCell>
                }
              </TableRow>
              <TableRow>
                <StyledTableHead sx={{ fontWeight: 700 }}>
                  Efetivo Pecuário
                </StyledTableHead>
                <StyledTableHead>Animais(n.º)</StyledTableHead>
                <StyledTableHead>Nº dias de dieta</StyledTableHead>
                <StyledTableHead>CN</StyledTableHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {create === true || editRow === true ?
                <>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Machos com < 6 meses"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_1_animais"
                        value={obj_tabela_editar?.camp_1_animais}
                        onChange={onInputChange}
                        error={error_camp_1_animais}
                        helperText={error_camp_1_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_1_dias"
                        value={obj_tabela_editar?.camp_1_dias}
                        onChange={onInputChange}
                        error={error_camp_1_dias}
                        helperText={error_camp_1_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_1_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_1_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Fêmeas com < 6 meses"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_2_animais"
                        value={obj_tabela_editar?.camp_2_animais}
                        onChange={onInputChange}
                        error={error_camp_2_animais}
                        helperText={error_camp_2_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_2_dias"
                        value={obj_tabela_editar?.camp_2_dias}
                        onChange={onInputChange}
                        error={error_camp_2_dias}
                        helperText={error_camp_2_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_2_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_2_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Machos de 6 meses a < 1 ano"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_3_animais"
                        value={obj_tabela_editar?.camp_3_animais}
                        onChange={onInputChange}
                        error={error_camp_3_animais}
                        helperText={error_camp_3_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_3_dias"
                        value={obj_tabela_editar?.camp_3_dias}
                        onChange={onInputChange}
                        error={error_camp_3_dias}
                        helperText={error_camp_3_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_3_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_3_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Fêmeas de 6 meses a < 1 ano"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_4_animais"
                        value={obj_tabela_editar?.camp_4_animais}
                        onChange={onInputChange}
                        error={error_camp_4_animais}
                        helperText={error_camp_4_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_4_dias"
                        value={obj_tabela_editar?.camp_4_dias}
                        onChange={onInputChange}
                        error={error_camp_4_dias}
                        helperText={error_camp_4_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_4_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_4_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Machos de 1 ano a < 2 anos"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_5_animais"
                        value={obj_tabela_editar?.camp_5_animais}
                        onChange={onInputChange}
                        error={error_camp_5_animais}
                        helperText={error_camp_5_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_5_dias"
                        value={obj_tabela_editar?.camp_5_dias}
                        onChange={onInputChange}
                        error={error_camp_5_dias}
                        helperText={error_camp_5_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_5_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_5_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Fêmeas de 1 ano a < 2 anos"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_6_animais"
                        value={obj_tabela_editar?.camp_6_animais}
                        onChange={onInputChange}
                        error={error_camp_6_animais}
                        helperText={error_camp_6_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_6_dias"
                        value={obj_tabela_editar?.camp_6_dias}
                        onChange={onInputChange}
                        error={error_camp_6_dias}
                        helperText={error_camp_6_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_6_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_6_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Machos com ≥ 2 anos"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_7_animais"
                        value={obj_tabela_editar?.camp_7_animais}
                        onChange={onInputChange}
                        error={error_camp_7_animais}
                        helperText={error_camp_7_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_7_dias"
                        value={obj_tabela_editar?.camp_7_dias}
                        onChange={onInputChange}
                        error={error_camp_7_dias}
                        helperText={error_camp_7_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_7_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_7_cn)}

                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHeadLeft>
                      {"Bovinos Fêmeas com ≥ 2 anos"}
                    </StyledTableHeadLeft>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_8_animais"
                        value={obj_tabela_editar?.camp_8_animais}
                        onChange={onInputChange}
                        error={error_camp_8_animais}
                        helperText={error_camp_8_animais ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="camp_8_dias"
                        value={obj_tabela_editar?.camp_8_dias}
                        onChange={onInputChange}
                        error={error_camp_8_dias}
                        helperText={error_camp_8_dias ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>
                      {obj_tabela_editar?.camp_8_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(obj_tabela_editar?.camp_8_cn)}
                    </StyledTableCell>
                  </TableRow>
                </>
                :
                <>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Machos com < 6 Mes"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_1_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_1_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_1_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_1_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Fêmeas com < 6 Mes"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_2_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_2_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_2_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_2_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Machos de 6 meses a < 1 ano"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_3_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_3_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_3_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_3_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Fêmeas de 6 meses a < 1 ano"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_4_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_4_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_4_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_4_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Machos de 1 ano a < 2 anos"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_5_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_5_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_5_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_5_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Fêmeas de 1 ano a < 2 anos"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_6_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_6_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_6_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_6_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Machos com ≥ 2 anos"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_7_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_7_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_7_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_7_cn)} </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableHead>
                      {"Bovinos Fêmeas com ≥ 2 anos"}
                    </StyledTableHead>
                    <StyledTableCell>{tabela?.camp_8_animais} </StyledTableCell>
                    <StyledTableCell>{tabela?.camp_8_dias} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{tabela?.camp_8_cn === undefined ? '00,00' : formatarNumero_recebido_com_casa_decimais(tabela?.camp_8_cn)} </StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableHead>TOTAL</StyledTableHead>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaCampoAnimais(tabela))} </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgray" }}> </StyledTableCell>
                    <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{formatarNumero_recebido_com_casa_decimais(somaCampoCN(tabela))} </StyledTableCell>
                  </TableRow>
                </>
              }
            </TableBody>
          </table>
        </TableContainer>
      }
      <ConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </>
  );
};
